import React, { useContext, useState, useRef, useEffect } from 'react';

import { useHistory } from 'react-router-dom';

import { NavLink } from 'react-router-dom';

//import Button from '../../../shared/components/FormElements/Button';
import Button from '../../components/FormElements/Button';

import { AuthContext } from '../../context/auth-context';
import './NavLinks.css';

const NavLinks = props => {

    const auth = useContext(AuthContext);
    //console.log(auth.userId);

    const [dropdownOpen, setDropdownOpen] = useState(false);

    const dropdownRef = useRef();

    // Close dropdown on outside click
    useEffect(() => {
        const handleClickOutside = event => {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target)
            ) {
                setDropdownOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    // Close dropdown after menu click
    const closeDropdown = () => {
        setDropdownOpen(false);

        if (props.onNavigate) {
            props.onNavigate();
        }
    };
    const history = useHistory();
    return (
        <ul className="nav-links">

            {/* Profile Dropdown */}
            {auth.isLoggedIn && (
                <li className="profile-menu" ref={dropdownRef}>
                    <button
                        className="profile-btn"
                        onClick={() => setDropdownOpen(prev => !prev)}
                    >
                        {/*Kuldeep ▼*/}
                        {/*Profile ▼*/}
                        {auth.userName} ▼
                        {/*{user.name} ▼  */}
                    </button>

                    {dropdownOpen && (
                        <ul className="dropdown-menu">

                            {auth.isLoggedIn && !auth.isRegistered && (
                                <li>

                                    <NavLink to={`/${auth.userId}/register`} onClick={closeDropdown}>
                                        Register
                                    </NavLink>

                                    {/*<Button to="/u1/register" onClick={closeDropdown}>Register</Button>*/}
                                </li>
                            )}

                            {auth.isLoggedIn && (
                                <li>
                                    <NavLink to={`/${auth.userId}/profile`} onClick={closeDropdown}>
                                        My Profile
                                    </NavLink>
                                </li>
                            )}

                            {auth.isLoggedIn && (
                                <li>
                                    {/*
                            <NavLink to="/logout" onClick={closeDropdown}>
                                Logout
                            </NavLink>
                            */}
                                    <Button danger onClick={() => {auth.logout(); history.push('/'); closeDropdown(); }}>LOGOUT</Button>
                                </li>
                            )}
                        </ul>
                    )}
                </li>
            )}


            {/* Auth Link */}
            {!auth.isLoggedIn && (
                <li>
                    <NavLink to="/auth" className="auth-link" onClick={props.onNavigate}>Sign Up/Login</NavLink>
                </li>
            )}

        </ul>
    );
};

export default NavLinks;
